<template>
  <Button
    type="button"
    icon="pi pi-times"
    class="p-button-danger"
    v-tooltip.bottom="$attrs.title"
  />
</template>